import { Link } from "react-router-dom";
import useDepartmentDoctors from "../hooks/useDepartmentDoctors";
import DoctorCard from "./DoctorCard";
import { Button } from "../ui/button";
import { Card, CardContent } from "../ui/card";
import { Phone, Mail, MapPin,Clock, CheckCircle2, Users, Award, Heart, Shield ,ArrowRight} from "lucide-react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../ui/accordion";
import SEO from "../pages/SEO"
import { useAppointment } from "../context/AppointmentContext"
export default function DermatologyPage() {
  const { open: openAppointment } = useAppointment();
  const doctors = useDepartmentDoctors("Dermatology");


  const subspecialties = [
    {
      title: "Medical Dermatology",
      description: "Acne, eczema, psoriasis, infections, dermatitis & allergic reactions.",
      image: "/MedicalDermatology.jpg",
    },
    {
      title: "Cosmetic Dermatology",
      description: "Skin rejuvenation, peels, anti-aging, glow treatments & pigmentation care.",
      image: "/CosmeticDermatology.jpg",
    },
    {
      title: "Laser Dermatology",
      description: "Laser hair removal, scar reduction, skin brightening & mole removal.",
      image: "/LaserDermatology.jpg",
    },
    {
      title: "Trichology (Hair Care)",
      description: "Hair fall, dandruff, alopecia & scalp treatments.",
      image: "/Trichology(Hair Care).jpg",
    },
    {
      title: "Venereology",
      description: "Diagnosis & treatment of sexually transmitted infections (STIs).",
      image: "/Venereology.jpg",
    },
    {
      title: "Leprosy Care",
      description: "Evaluation & management of Hansen's disease.",
      image: "/LeprosyCare.jpg",
    },
  ];
  const treatments = [
    "Acne & Acne Scar Treatment",
    "Pigmentation Therapy & Skin Brightening",
    "Laser Hair Removal (Face & Body)",
    "Botox & Fillers (Anti-Aging Solutions)",
    "Chemical Peels & Medi-Facials",
    "PRP Therapy for Hair Regrowth",
    "Wart, Mole & Skin Tag Removal",
    "Fungal & Bacterial Skin Infection Treatment",
    "STD Testing & Treatment",
  ];
  const whyChoose = [
    {
      icon: Users,
      title: "Expert Dermatologists",
      description: "Experienced dermatologists & cosmetology specialists",
    },
    {
      icon: Award,
      title: "Latest Technology",
      description: "Latest laser & aesthetic technology",
    },
    {
      icon: Heart,
      title: "Personalized Care",
      description: "Personalized skincare & hair regrowth plans",
    },
    {
      icon: Shield,
      title: "Confidential Treatment",
      description: "Confidential treatment for STDs & sensitive conditions",
    },
    {
      icon: CheckCircle2,
      title: "FDA Approved",
      description: "Safe, US-FDA approved dermatology procedures",
    },
  ];
  const articles = [
    {
      title: "How to Prevent Acne Breakouts Effectively",
      excerpt:
        "Discover proven strategies and skincare routines to prevent acne breakouts and maintain clear, healthy skin.",
    },
    {
      title: "Top Benefits of Laser Hair Removal",
      excerpt: "Learn about the advantages of laser hair removal including long-lasting results and smooth skin.",
    },
    {
      title: "Is Your Skin Sensitive? Signs & Care Tips",
      excerpt: "Identify signs of sensitive skin and learn the best practices for gentle, effective skincare.",
    },
    {
      title: "Understanding Hair Fall — Causes & Best Treatments",
      excerpt: "Explore the common causes of hair loss and discover the most effective treatment options available.",
    },
  ];
  const faqs = [
    {
      question: "Do you provide laser treatments for pigmentation or scars?",
      answer:
        "Yes, we offer advanced laser solutions for pigmentation, acne scars, and skin resurfacing. Our laser technology is safe and effective for various skin types, and our dermatologists will assess your skin condition to recommend the most suitable treatment plan.",
    },
    {
      question: "Are cosmetic procedures safe?",
      answer:
        "Yes, all cosmetic procedures are performed by certified specialists using safe and approved technologies. We use US-FDA approved equipment and follow international safety protocols. A thorough consultation and skin assessment are conducted before any procedure to ensure optimal safety and results.",
    },
    {
      question: "Do you offer treatment for hair fall?",
      answer:
        "Yes, treatments include PRP therapy, medications, and customized scalp care programs. Our trichologists conduct a comprehensive evaluation to identify the underlying cause of hair fall and create a personalized treatment plan that may include topical solutions, oral medications, and advanced therapies.",
    },
  ];
  const schema = [
  {
    "@context": "https://schema.org",
    "@type": "MedicalClinic",
    "name": "MAMS Hospitals Dermatology Department",
    "url": "https://mamshospitals.com/dermatology",
    "logo": "https://mamshospitals.com/MAMS-Logo.png",
    "image": "https://mamshospitals.com/Dermatology.jpg",
    "description": "MAMS Hospitals provides advanced dermatology treatment in Hyderabad including acne treatment, laser dermatology, skin allergy treatment, hair fall treatment, cosmetic dermatology, and PRP therapy.",
    "medicalSpecialty": "Dermatology",
    "telephone": "+91-7399999981",
    "priceRange": "$$",

    "address": {
      "@type": "PostalAddress",
      "streetAddress": "Bachupally",
      "addressLocality": "Hyderabad",
      "addressRegion": "Telangana",
      "postalCode": "500090",
      "addressCountry": "IN"
    },

    "availableService": [
      {
        "@type": "MedicalProcedure",
        "name": "Acne & Scar Treatment"
      },
      {
        "@type": "MedicalProcedure",
        "name": "Laser Hair Removal"
      },
      {
        "@type": "MedicalProcedure",
        "name": "PRP Hair Regrowth Therapy"
      },
      {
        "@type": "MedicalProcedure",
        "name": "Chemical Peels & Skin Brightening"
      },
      {
        "@type": "MedicalProcedure",
        "name": "Skin Allergy & Infection Treatment"
      }
    ],

    "sameAs": [
      "https://www.facebook.com/MAMSHospitals",
      "https://www.instagram.com/mams_hospitals"
    ]
  },

  {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": [
      {
        "@type": "Question",
        "name": "Do you provide laser treatments for pigmentation and scars?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Yes, MAMS Hospitals offers advanced laser treatments for pigmentation, acne scars, skin resurfacing, and laser hair removal."
        }
      },
      {
        "@type": "Question",
        "name": "Do you provide hair fall treatment?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Yes, we provide PRP therapy, scalp treatments, medications, and customized hair regrowth plans."
        }
      },
      {
        "@type": "Question",
        "name": "Are cosmetic dermatology procedures safe?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Yes, all cosmetic dermatology procedures at MAMS Hospitals are performed using US-FDA approved technologies and safety protocols."
        }
      }
    ]
  },

  {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "name": "Dermatology Department - MAMS Hospitals",
    "url": "https://mamshospitals.com/dermatology",
    "description": "Best dermatology hospital in Hyderabad offering acne treatment, laser dermatology, PRP therapy, cosmetic dermatology, hair fall treatment, and skin allergy care.",
    "keywords": [
      "Best Dermatologist Hyderabad",
      "Dermatology Hospital Hyderabad",
      "Skin Specialist Hyderabad",
      "Hair Fall Treatment Hyderabad",
      "Laser Hair Removal Hyderabad",
      "PRP Hair Treatment Hyderabad",
      "Dermatology Hospital Bachupally"
    ]
  }
];

  return (
    <>
    <SEO
      title="Best Dermatology Hospital in Hyderabad | Skin & Hair Specialists | MAMS Hospitals"
      description="MAMS Hospitals offers advanced dermatology treatment in Hyderabad including acne treatment, laser dermatology, PRP hair therapy, cosmetic dermatology, skin allergy treatment, and hair fall treatment."
      keywords="best dermatologist Hyderabad,
    dermatology hospital Hyderabad,
    skin specialist Hyderabad,
    hair fall treatment Hyderabad,
    laser hair removal Hyderabad,
    PRP hair treatment Hyderabad,
    acne scar treatment Hyderabad,
    cosmetic dermatology Hyderabad,
    skin allergy treatment Hyderabad,
    chemical peel Hyderabad,
    anti aging treatment Hyderabad,
    dermatology hospital Bachupally,
    MAMS Hospitals Dermatology"
      schema={schema}
    />
    <div className="flex flex-col min-h-screen">
      {/* Hero Section */}
      <section className="relative bg-gradient-to-br from-teal-50 via-white to-blue-50 py-12 md:py-24">
        <div className="container mx-auto px-0 max-w-6xl">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-12 items-center">
            <div>
              <div className="inline-block bg-teal-100 text-teal-700 px-4 py-2 rounded-full text-sm font-semibold mb-6">
                Best Dermatology Hospital in Hyderabad
              </div>

              <h1 className="text-3xl md:text-5xl font-bold text-gray-900 mb-6">Healthy Skin, Confident You</h1>

              <p className="text-lg text-gray-700 mb-8 leading-relaxed">
                MAMS Hospitals is recognized as one of the Best Dermatology Hospitals in Hyderabad, offering advanced
                care for skin, hair, and nail conditions using state-of-the-art technology and personalized care.
              </p>

              <div className="flex flex-col sm:flex-row gap-4">

                <Button className="bg-teal-600 hover:bg-teal-700 text-white rounded-full px-8" size="lg" onClick={openAppointment}>
                    Book Appointment
                  </Button>

                <Link to="tel:+91-7399999981">
                  <Button
                    className="border-teal-600 text-teal-600 hover:bg-teal-50 rounded-full px-8"
                    variant="outline"
                    size="lg"
                  >
                    <Phone className="mr-2 h-5 w-5" />
                    Call Us
                  </Button>
                </Link>

              </div>
            </div>

            <div className="relative">
              <div className="absolute -top-4 -right-4 bg-teal-600 text-white p-6 rounded-2xl shadow-xl z-10">
                <div className="text-3xl font-bold">FDA</div>
                <div className="text-sm">Approved Care</div>
              </div>

              <img
                src="/Dermatology.jpg"
                alt="Dermatology at MAMS Hospital"
                className="rounded-2xl shadow-2xl w-full"
              canonicalUrl="https://mamshospitals.com/departments/dermatology"
      />
            </div>
          </div>
        </div>
      </section>

      {/* Sub-Specialties */}
      <section className="py-16 md:py-20 bg-white">
        <div className="container mx-auto px-0 max-w-6xl">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">Sub-Specialities in Dermatology (DVL)</h2>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto">
              Comprehensive skin, hair, and nail care across multiple specializations
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {subspecialties.map((specialty, index) => (
              <Card key={index} className="group hover:shadow-xl transition-all duration-300 border-gray-200 hover:border-teal-500">
                <CardContent className="p-0">
                  <div className="relative h-48 overflow-hidden rounded-t-lg">
                    <img
                      src={specialty.image || "/placeholder.svg"}
                      alt={specialty.title}
                      className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-300"
                    />
                  </div>

                  <div className="p-6">
                    <h3 className="text-xl font-bold text-gray-900 mb-3">{specialty.title}</h3>
                    <p className="text-gray-600 leading-relaxed">{specialty.description}</p>
                  </div>
                </CardContent>
              </Card>
            ))}
          </div>
        </div>
      </section>

      {/* Treatments */}
      <section className="py-16 md:py-20 bg-gradient-to-br from-gray-50 to-blue-50">
        <div className="container mx-auto px-0 max-w-6xl">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">Treatments & Procedures</h2>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto">
              Advanced dermatology procedures performed with precision and care
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-4">
            {treatments.map((treatment, index) => (
              <div key={index} className="flex items-start gap-3 bg-white p-4 rounded-lg shadow-sm">
                <CheckCircle2 className="h-6 w-6 text-teal-600 flex-shrink-0 mt-1" />
                <span className="text-gray-700 font-medium">{treatment}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Why Choose */}
      <section className="py-16 md:py-20 bg-white">
        <div className="container mx-auto px-0 max-w-6xl">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
              Why Choose MAMS Hospitals for Dermatology
            </h2>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto">Experience safe and effective dermatology care</p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {whyChoose.map((item, index) => (
              <Card key={index} className="border-gray-200 hover:shadow-lg transition-shadow">
                <CardContent className="p-6">
                  <div className="w-14 h-14 bg-teal-100 rounded-full flex items-center justify-center mb-4">
                    <item.icon className="h-7 w-7 text-teal-600" />
                  </div>

                  <h3 className="text-xl font-bold text-gray-900 mb-3">{item.title}</h3>
                  <p className="text-gray-600 leading-relaxed">{item.description}</p>
                </CardContent>
              </Card>
            ))}
          </div>

          {/* <div className="mt-12 text-center">
            <p className="text-gray-600 mb-2">Convenient location near Miyapur & Bachupally</p>
          </div> */}
        </div>
      </section>

      {/* Meet Specialist */}
                {doctors.length > 0 && (
          <section className="py-16 px-0 bg-apple-gray-50">
            <div className="container mx-auto max-w-6xl">
              <div className="text-center mb-12">
                <h2 className="text-3xl md:text-4xl font-semibold text-apple-gray-500 mb-4">Meet Our Specialists</h2>
              </div>
              <div className="relative">
                <button
                  onClick={() => { const el = document.getElementById('doc-scroll'); if(el) el.scrollBy({ left: -340, behavior: 'smooth' }); }}
                  className="absolute left-0 top-1/2 -translate-y-1/2 z-10 bg-white shadow-md rounded-full p-2 hover:bg-gray-100"
                >
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" /></svg>
                </button>
                <div id="doc-scroll" className="flex gap-6 overflow-x-auto scroll-smooth px-10 scrollbar-hide pb-4">
                  {doctors.map(doctor => (
                    <div key={doctor.id} className="w-[280px] sm:w-[300px] flex-shrink-0">
                      <DoctorCard doctor={{
                        name: doctor.title.rendered,
                        slug: doctor.slug,
                        imageUrl: doctor._embedded?.["wp:featuredmedia"]?.[0]?.source_url || "",
                        specialty: doctor._embedded?.["wp:term"]?.[0]?.[0]?.name || "",
                        designation: doctor.acf?.designation || "",
                        qualification: doctor.acf?.qualification || "",
                        experience: doctor.acf?.experience || "",
                      }} />
                    </div>
                  ))}
                </div>
                <button
                  onClick={() => { const el = document.getElementById('doc-scroll'); if(el) el.scrollBy({ left: 340, behavior: 'smooth' }); }}
                  className="absolute right-0 top-1/2 -translate-y-1/2 z-10 bg-white shadow-md rounded-full p-2 hover:bg-gray-100"
                >
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" /></svg>
                </button>
              </div>
              <div className="text-center mt-8">
                <Link to="/doctors">
                  <button className="px-6 py-3 rounded-full border text-sm font-medium inline-flex items-center gap-2">
                    View All Doctors
                  </button>
                </Link>
              </div>
            </div>
          </section>
          )}

      {/* Articles */}
      {/* <section className="py-16 md:py-20 bg-white">
        <div className="container mx-auto px-0 max-w-6xl">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">Recent Articles</h2>
            <p className="text-lg text-gray-600">Stay informed about skin and hair care</p>
          </div>

          <div className="grid md:grid-cols-2 gap-6">
            {articles.map((article, index) => (
              <Card key={index} className="group hover:shadow-xl transition-all duration-300 cursor-pointer border-gray-200">
                <CardContent className="p-6">
                  <h3 className="text-xl font-bold text-gray-900 mb-3 group-hover:text-teal-600 transition-colors">
                    {article.title}
                  </h3>

                  <p className="text-gray-600 leading-relaxed">{article.excerpt}</p>
                </CardContent>
              </Card>
            ))}
          </div>
        </div>
      </section> */}

      {/* FAQ */}
      <section className="py-16 md:py-20 bg-gray-50">
        <div className="container mx-auto px-0 max-w-4xl">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">Frequently Asked Questions</h2>
            <p className="text-lg text-gray-600">Get answers to common questions about dermatology</p>
          </div>

          <Accordion type="single" collapsible className="bg-white rounded-lg shadow-sm">
            {faqs.map((faq, index) => (
              <AccordionItem key={index} value={`item-${index}`}>
                <AccordionTrigger className="text-left px-6 hover:text-teal-600">
                  {faq.question}
                </AccordionTrigger>

                <AccordionContent className="px-6 text-gray-600 leading-relaxed">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </section>

      {/* Contact & Appointment Section */}
      <section className="py-16 px-0 bg-apple-teal text-white">
        <div className="container mx-auto max-w-6xl">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-semibold mb-4">Book an Appointment</h2>
            <p className="text-white/90 max-w-2xl mx-auto">
              Your heart health is our top priority. Book an appointment today with Hyderabad's trusted experts at MAMS Hospitals
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
            <Card className="bg-white/10 backdrop-blur-sm border-white/20 rounded-3xl">
              <CardContent className="p-6 text-center">
                <Phone className="h-8 w-8 mx-auto mb-4 text-white" />
                <h3 class="font-bold text-white mb-2">Call Us</h3>
                <a href="tel:+917399999981" className="text-white/90 hover:text-white">
                  +91-7399999981
                </a>
              </CardContent>
            </Card>

            <Card className="bg-white/10 backdrop-blur-sm border-white/20 rounded-3xl">
              <CardContent className="p-6 text-center">
                <Mail className="h-8 w-8 mx-auto mb-4 text-white" />
                <h3 class="font-bold text-white mb-2">Email Us</h3>
                <a href="mailto: info@mamshospitals.com" className="text-white/90 hover:text-white">
                   info@mamshospitals.com
                </a>
              </CardContent>
            </Card>

            <Card className="bg-white/10 backdrop-blur-sm border-white/20 rounded-3xl">
              <CardContent className="p-6 text-center">
                <MapPin className="h-8 w-8 mx-auto mb-4 text-white" />
                <h3 class="font-bold text-white mb-2">Visit Us</h3>
                <p className="text-white/90">Bachupally, Miyapur</p>
              </CardContent>
            </Card>
          </div>

          <div className="text-center">
            {/* <Link href="/book-appointment">
              <Button size="lg" variant="secondary" className="rounded-full">
                <Calendar className="mr-2 h-5 w-5" />
                Schedule Your Appointment
              </Button>
            </Link> */}
          </div>
        </div>
      </section>

      {/* Emergency Banner */}
      <section className="py-8 px-0 bg-red-600 text-white">
        <div className="container mx-auto max-w-6xl">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <div className="flex items-center gap-4">
              <Clock className="h-8 w-8" />
              <div>
                <h3 className="text-xl font-bold">24/7 Emergency Care</h3>
                <p className="text-white/90">Fully equipped emergency department </p>
              </div>
            </div>
            <a href="tel:+917399999981">
              <Button size="lg" variant="secondary" className="w-full sm:w-auto rounded-full bg-white text-red-600 hover:bg-gray-100">
                <Phone className="mr-2 h-5 w-5" />
                Call Emergency
              </Button>
            </a>
          </div>
        </div>
      </section>
    </div>
    </>
  );
}
